module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tx-c m-b-10"
  }, [_vm._v("财务数据统计")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "project_name",
      "label": "项目",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "统计对象"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "month",
      "label": "本月累计开票收入",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "year",
      "label": "本年累计开票收入",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "month_before",
      "label": "截止本月末止累计开票收入",
      "min-width": "400"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-504be29a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Self/finance.vue
// module id = 1860
// module chunks = 2